module.exports = __webpack_public_path__ + "static/media/ClanOffcPro-Bold.976d5bed.woff";